import { IResponse } from "@app/common/types/http";
import { HTTP_DISPENSARY } from "@app/config/axios";
import { clearEmptyKeys } from "@app/common/utils/utils";
import type { ITopInventoryOutReportFilters, ITopInventoryOutReportItem } from "./types";

export async function topInventoryOutReportService(
  filters: ITopInventoryOutReportFilters,
  token: string
) {
  const sanitizedFilters = clearEmptyKeys(filters);
  const res = await HTTP_DISPENSARY(token).get<IResponse<ITopInventoryOutReportItem[]>>(
    "/dispensaries/top-inventory-consumption-report",
    { params: sanitizedFilters }
  );
  return res.data;
}

export async function downloadTopInventoryOutReportExcel(
  filters: ITopInventoryOutReportFilters,
  token: string
) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { page, perpage, ...rest } = filters;
  const sanitizedFilters = clearEmptyKeys(rest);
  const res = await HTTP_DISPENSARY(token).get<IResponse<{ base64: string }>>(
    "/dispensaries/top-inventory-consumption-report/excel",
    { params: sanitizedFilters }
  );
  return res.data;
}
